import { Form, Select } from 'antd'
import SearchItem from './SearchItem'
import AddCart from './AddCart'
import RemoveCart from './RemoveCart'

const actions = [
  {
    label: 'Buscar Item',
    value: 'SEARCH',
  },
  {
    label: 'Adicionar ao carrinho',
    value: 'ADD_CART',
  },
  {
    label: 'Remover do carrinho',
    value: 'REMOVE_CART',
  },
  {
    label: 'Consultar Carrinho',
    value: 'GET_CART',
  },
]

export default function CatalogIntegrationForm({
  form,
  parameters,
  fieldName,
}) {
  const type = Form.useWatch(['actions', fieldName, 'action', 'type'], form)

  return (
    <>
      <Form.Item label={'Tipo de ação'} name={[fieldName, 'action', 'type']}>
        <Select options={actions} placeholder={'Selecione o tipo de ação'} />
      </Form.Item>
      {type === 'SEARCH' && (
        <SearchItem fieldName={fieldName} parameters={parameters} form={form} />
      )}
      {type === 'ADD_CART' && (
        <AddCart fieldName={fieldName} parameters={parameters} />
      )}
      {type === 'REMOVE_CART' && (
        <RemoveCart fieldName={fieldName} parameters={parameters} />
      )}
    </>
  )
}
